import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import classNames from "../../../helpers/classNames";
import Link from "../Common/Link";
import { SideEditOptions } from "../../../types/elements";
import Typography from "../Common/Typography";
import RenderElement from "../../../helpers/RenderElement";
import { Menu, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import ReactCountryFlag from "react-country-flag";
import { useEditor } from "../../../hooks/EditorProvider";
import navbarItemsRender from "../../../helpers/navbarItemsRender";
import { useSite } from "../../../hooks/SiteProvider";
const navbarConfig = [
    { type: SideEditOptions.Menu },
    {
        type: SideEditOptions.Select,
        config: {
            key: "navbar-location",
            label: "Navbar locatie",
            defaultValue: "top",
            open: false,
            selectOptions: [
                {
                    value: "top",
                    label: "Altijd boven",
                },
                {
                    value: "sticky",
                    label: "Meebewegen met scrollen",
                },
            ],
        },
    },
    {
        type: SideEditOptions.Select,
        config: {
            key: "menu-location",
            label: "Menu locatie",
            defaultValue: "justify-start",
            open: false,
            selectOptions: [
                {
                    value: "justify-start",
                    label: "Links",
                },
                {
                    value: "justify-center",
                    label: "Midden",
                },
                {
                    value: "justify-end",
                    label: "Rechts",
                },
            ],
        },
    },
    {
        type: SideEditOptions.TextColor,
        config: {
            key: "text-color",
            valueKey: "textColor",
            defaultValue: "text-white",
            label: "Tekst kleur",
        },
    },
    {
        type: SideEditOptions.BackgroundColor,
        config: {
            key: "bg-active-item",
            valueKey: "backgroundColor",
            defaultValue: "bg-site-400",
            label: "Kleur active item",
        },
    },
    {
        type: SideEditOptions.TextColor,
        config: {
            key: "text-active-color",
            valueKey: "textColor",
            defaultValue: "text-white",
            label: "Tekst active item kleur",
        },
    },
    {
        type: SideEditOptions.BackgroundColor,
        config: {
            key: "language-bg-color",
            valueKey: "backgroundColor",
            defaultValue: "bg-site-400",
            label: "Kleur taal button",
        },
    },
];
const LanguagePicker = ({ renderElement }) => {
    const { languages, locale } = useSite();
    const localeMapper = {
        EN: "GB",
    };
    if (languages.length === 0)
        return null;
    return (_jsxs(Menu, { as: "div", className: "relative inline-block text-left", children: [_jsx("div", { children: _jsx(Menu.Button, { as: "div", "editor-focuskey": "language-1", className: classNames("ml-4 flex h-[36px] cursor-pointer items-center justify-center  rounded-md px-3 py-2 ", renderElement.renderProp("menu-1", "language-bg-color")
                        ?.backgroundColor || "bg-site-400"), children: _jsx(ReactCountryFlag, { countryCode: localeMapper[locale?.toUpperCase()] || locale?.toUpperCase(), style: { width: 24 }, svg: true }) }) }), _jsx(Transition, { as: Fragment, enter: "transition ease-out duration-100", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95", children: _jsx(Menu.Items, { className: "absolute right-0 z-10 mt-2 flex origin-top-right rounded-md bg-white p-2 pl-3 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", children: _jsx("div", { className: "py-1", children: languages
                            .filter((l) => l.code.toLowerCase() !== locale)
                            .map((language) => (_jsx(Menu.Item, { children: ({ active }) => (_jsx(Link, { href: `/${language.code.toLowerCase()}`, className: classNames(active ? "bg-gray-100 text-gray-900" : "text-gray-700", "-2 block rounded-md p-2"), children: _jsx(ReactCountryFlag, { countryCode: localeMapper[language.code] || language.code, style: { width: 14 }, svg: true, alt: localeMapper[language.code] || language.code }) })) }, language.id))) }) }) })] }));
};
const NavbarItemDesktop = ({ item, activePage, renderElement }) => {
    if (item.items.length > 0) {
        return (_jsxs(Menu, { as: "div", className: "relative inline-block text-left", children: [_jsx("div", { children: _jsxs(Menu.Button, { className: classNames(item.href === activePage
                            ? `${renderElement.renderProp("menu-1", "bg-active-item")
                                ?.backgroundColor || "bg-site-400"} ${renderElement.renderProp("menu-1", "text-active-color")
                                ?.textColor || "text-white"}`
                            : `${renderElement.renderProp("menu-1", "text-color")
                                ?.textColor || "text-black"} opacity-80 hover:opacity-100`, "flex justify-center rounded-md px-3 py-2 "), children: [_jsx(Typography, { component: "span", "editor-focuskey": "menu-1", children: item.name }), _jsx(ChevronDownIcon, { className: "-mr-1 ml-2 h-5 w-5", "aria-hidden": "true" })] }) }), _jsx(Transition, { as: Fragment, enter: "transition ease-out duration-100", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95", children: _jsx(Menu.Items, { className: "absolute right-0 z-10  mt-2 w-56 origin-top-right rounded-md bg-white p-2 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", children: _jsx("div", { className: "py-1", children: item.items.map((subItem) => (_jsx(Menu.Item, { children: ({ active }) => (_jsx(Link, { href: subItem.href, className: classNames(active ? "bg-gray-100 text-gray-900" : "text-gray-700", "block rounded-md px-4 py-2"), children: _jsx(Typography, { component: "span", children: subItem.name }) })) }))) }) }) })] }));
    }
    return (_jsx(Link, { href: item.href, className: classNames(item.href === activePage
            ? `${renderElement.renderProp("menu-1", "bg-active-item")
                ?.backgroundColor || "bg-site-400"} ${renderElement.renderProp("menu-1", "text-active-color")
                ?.textColor || "text-white"}`
            : `${renderElement.renderProp("menu-1", "text-color")?.textColor ||
                "text-black"} opacity-80 hover:opacity-100`, "rounded-md px-3 py-2"), children: _jsx(Typography, { component: "span", "editor-focuskey": "menu-1", children: item.name }) }, item.id));
};
const NavbarItemMobile = ({ item, activePage, elementProps }) => {
    const renderElement = RenderElement.setProps(elementProps);
    const [activeSub, setActiveSub] = useState(false);
    if (item.items?.length > 0) {
        return (_jsxs("div", { className: "relative inline-block text-left", children: [_jsxs("div", { onClick: () => setActiveSub(!activeSub), className: classNames(item.href === activePage
                        ? `${renderElement.renderProp("menu-1", "bg-active-item")
                            ?.backgroundColor || "bg-site-400"} ${renderElement.renderProp("menu-1", "text-active-color")
                            ?.textColor || "text-white"}`
                        : `${renderElement.renderProp("menu-1", "text-color")?.textColor ||
                            "text-black"} opacity-80 hover:opacity-100`, "flex rounded-md px-3 py-2 "), children: [_jsx(Typography, { component: "span", "editor-focuskey": "menu-1", children: item.name }), _jsx(ChevronDownIcon, { className: "-mr-1 ml-2 h-5 w-5", "aria-hidden": "true" })] }), activeSub && (_jsx("div", { className: "flex flex-col py-1", children: item.items.map((subItem) => (_jsx(Disclosure.Button, { as: Link, href: subItem.href, className: classNames(item.href === activePage
                            ? `${renderElement.renderProp("menu-1", "text-active-item")
                                ?.backgroundColor || "bg-site-400"} ${renderElement.renderProp("menu-1", "text-active-color")
                                ?.textColor || "text-white"}`
                            : `${renderElement.renderProp("menu-1", "text-color")
                                ?.textColor || "text-black"} opacity-80 hover:opacity-100`, "rounded-md px-3 py-2 "), children: _jsx(Typography, { component: "span", children: subItem.name }) }, subItem.id))) }))] }));
    }
    return (_jsx(Disclosure.Button, { as: Link, href: item.href, className: classNames(item.href === activePage
            ? `${renderElement.renderProp("menu-1", "text-active-item")
                ?.backgroundColor || "bg-site-400"} ${renderElement.renderProp("menu-1", "text-active-color")
                ?.textColor || "text-white"}`
            : `${renderElement.renderProp("menu-1", "text-color")?.textColor ||
                "text-white"} opacity-80 hover:opacity-100`, "rounded-md px-3 py-2 "), children: _jsx(Typography, { component: "span", children: item.name }) }, item.id));
};
const NavbarDefault = ({ menus, pages, activePage, elementId, elementProps, }) => {
    const { mode } = useEditor();
    const { locale } = useSite();
    const renderElement = RenderElement.setProps(elementProps);
    const menu = menus?.find((m) => m.id === renderElement.renderMenu("menu-1")?.selected);
    const items = menu ? JSON.parse(menu.items) : [];
    const navbarItems = navbarItemsRender(items, pages);
    renderElement.renderProp("menu-1", "menu-location")?.value;
    return (_jsx(Disclosure, { as: "div", "editor-key": "container-1", ...renderElement.renderClassName("container-1", "", {
            backgroundColor: "bg-site-500",
        }, renderElement.renderProp("menu-1", "navbar-location")?.value ===
            "sticky"
            ? "sticky z-10 w-full border-b top-0"
            : ""), "editor-elementid": elementId, children: ({ open }) => (_jsxs(_Fragment, { children: [_jsx("div", { className: "mx-auto max-w-7xl px-2 sm:px-6 lg:px-8", children: _jsxs("div", { className: "relative flex h-16 items-center justify-between", "editor-focuskey": "container-1", children: [_jsx("div", { className: "absolute inset-y-0 left-0 flex items-center sm:hidden", children: _jsxs(Disclosure.Button, { className: `text-white-100/80 inline-flex items-center justify-center rounded-md p-2  focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white`, children: [_jsx("span", { className: "sr-only", children: "Open main menu" }), open ? (_jsx(XMarkIcon, { className: `block h-6 w-6 ${renderElement.renderProp("menu-1", "text-color")
                                                ?.textColor || "text-white"}`, "aria-hidden": "true" })) : (_jsx(Bars3Icon, { className: `block h-6 w-6 ${renderElement.renderProp("menu-1", "text-color")
                                                ?.textColor || "text-black"}`, "aria-hidden": "true" }))] }) }), _jsxs("div", { className: "flex flex-1 items-center justify-center sm:items-stretch sm:justify-start", children: [_jsx("div", { className: `flex flex-shrink-0 items-center`, children: _jsx("div", { className: "md:w-24", children: _jsx(Link, { href: `/${locale}`, children: _jsx("img", { "editor-key": "logo-1", ...renderElement.renderClassName("logo-1", "block h-8 w-auto"), ...renderElement.renderImage("logo-1", {
                                                        src: "https://tailwindui.com/img/logos/mark.svg?color=white",
                                                    }) }) }) }) }), _jsx("div", { className: `hidden w-full items-center ${renderElement.renderProp("menu-1", "menu-location")
                                            ?.value || "justify-center"} sm:ml-6 sm:flex`, children: _jsxs("div", { className: `flex  space-x-4`, "editor-key": "menu-1", "editor-menu-selected": renderElement.renderMenu("menu-1").selected, ...renderElement.renderAttributeOptions(navbarConfig, "menu-1"), children: [navbarItems.length === 0 && mode === "editor" && (_jsx("div", { className: "rounded-md bg-black/40 p-2 text-white", children: _jsx(Typography, { component: "span", "editor-focuskey": "menu-1", children: "Selecteer een menu" }) })), navbarItems?.map((item) => (_jsx(NavbarItemDesktop, { item: item, activePage: activePage, renderElement: renderElement }, item.id)))] }) }), _jsx("div", { className: "hidden items-center md:flex", children: _jsx(LanguagePicker, { renderElement: renderElement }) })] })] }) }), _jsxs(Disclosure.Panel, { className: "sm:hidden", children: [_jsx("div", { className: "flex flex-col space-y-1 px-2 pb-3 pt-2", children: navbarItems?.map((item) => (_jsx(NavbarItemMobile, { item: item, activePage: activePage, elementProps: elementProps }, item.name))) }), _jsx("div", { className: "block py-4 md:hidden", children: _jsx(LanguagePicker, { renderElement: renderElement }) })] })] })) }));
};
export default NavbarDefault;
//# sourceMappingURL=NavbarDefault.js.map